module.exports = __webpack_public_path__ + "static/media/rg-front.83dcda95.svg";